import { Component, ChangeDetectionStrategy} from '@angular/core';
import { IHeaderGroupAngularComp } from 'ag-grid-angular';
import {DomSanitizer} from "@angular/platform-browser";

@Component({ standalone: false,
  selector: 'irb-header-group',
  templateUrl: './header-group.component.html',
  styleUrls: ['./header-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbHeaderGroupComponent implements IHeaderGroupAngularComp {

  params: any;
  displayName: string;
  maxWidth = '300px';
  irbColInfo: any;

  constructor(private sanitizer: DomSanitizer) {}

  agInit(params: any): void {
    this.params = params;
    this.displayName = params.value;
    this.maxWidth = this.params.maxWidth ? this.params.maxWidth : '300px';

    if (this.params.irbColInfo) {
      this.irbColInfo = this.sanitizer.bypassSecurityTrustHtml(this.params.irbColInfo);
    }
  }
}
